import {PortsItemChunk} from "../../chunks/types/PortsItemChunk";
import {getPortNameFromPortDeclChunk} from "./getPortNameFromPortDeclChunk";

export function getPortNameFromPortsItemChunk(
  portsItemChunk: PortsItemChunk
): string {
  const {
    captures: {
      1: portDeclChunk
    }
  } = portsItemChunk;
  return getPortNameFromPortDeclChunk(portDeclChunk);
}
